import { handlers } from '_helpers';
import crFetch from '_helpers/fetch';

const { handleResponseAsync } = handlers;

async function getAll(accountID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/license?accountID=${accountID}`
      }))
  );
}

async function getById(licenseID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/license/${licenseID}`
      }))
  );
}

async function create(license) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: '/license',
        body: JSON.stringify(license)
      }))
  );
}

async function update(license) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'PUT',
        url: `/license/${license.licenseID}`,
        body: JSON.stringify(license)
      }))
  );
}

async function link(license) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'PUT',
        url: `/license/${license.licenseID}/link`,
        body: JSON.stringify(license)
      }))
  );
}

async function unAssign(licenseID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'PUT',
        url: `/license/${licenseID}/unassign`
      }))
  );
}

async function Delete(licenseID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'DELETE',
        url: `/license/${licenseID}`
      }))
  );
}

const licenseService = {
  getAll,
  getById,
  create,
  update,
  delete: Delete,
  link,
  unAssign,
};

export default licenseService;
